import { FormInstance } from 'antd'
import { TFunction } from 'next-i18next'
import { AppDispatch } from 'src/app/store'
import { showNotification } from 'src/core/helpers'
import AcquisitionCheckbox from './AcquisitionCheckbox/AcquisitionCheckbox'
import AcquisitionPrices from './AcquisitionPrices/AcquisitionPrices'
import AcquisitionDateForm from './AcquisitionDateForm/AcquisitionDateForm'
import AcquisitionStockField from './AcquisitionStockField/AcquisitionStockField'
import ProjectIdAcquisition from './ProjectIdAcquisition/ProjectIdAcquisition'
import SellerUserAcquisition from './SellerUserAcquisition/SellerUserAcquisition'
import AcquisitionIsCommitment from './AcquisitionIsCommitment/AcquisitionIsCommitment'

import {
  setBrokeragePurchasePriceCurrency,
  setBrokerageSalePriceCurrency,
  resetPurchaseOperationSuccess,
  resetProjectCreateAllState,
  resetValidateEmailState,
  resetUserRegisterState,
  resetValidateProjectId,
} from 'src/features'


export const acquisitionSections = {
  AcquisitionPrices,
  AcquisitionStockField,
  ProjectIdAcquisition,
  SellerUserAcquisition,
  AcquisitionCheckbox,
  AcquisitionDateForm,
  AcquisitionIsCommitment
}

export const resetAcquisitionForm = (
  dispatch: AppDispatch, setStockRestFlag: Function,
  form: FormInstance, showResetMessage: boolean,
  setShowTableLink: Function, t: TFunction,
  setIsCommitment: Function
) => {
  dispatch(setBrokerageSalePriceCurrency('EUR'))
  dispatch(setBrokeragePurchasePriceCurrency('EUR'))
  dispatch(resetValidateProjectId())
  dispatch(resetValidateEmailState())
  dispatch(resetPurchaseOperationSuccess())
  dispatch(resetUserRegisterState())
  dispatch(resetProjectCreateAllState())
  setStockRestFlag('REST')
  setIsCommitment(false)
  form.resetFields()
  if (showResetMessage) {
    setShowTableLink(false)
    showNotification('info', t('admin.Brokerage.ResetForm'))
  }
}
